

var eye, lids = null;
var iris = {ref: null, x: 20, y: 20, w: 15, h: 28, color:'', lerp: 0};
var mouse = {x: 4, y: 4, oldX: 4, oldY: 4};
var r = iris.w/2;
var center = {
  x: $('.eye').width()/2 - r, 
  y: $('.eye').height()/2 - r
};
var distanceThreshold = $('.eye').width()/2 - r;
var xp = 3;
var yp = 4;
// entry point
window.onload = init;
function init() {
  eye = $('.eye');
  iris.ref = $('.iris');
  iris.x = (iris.ref.css('left'));
  iris.y = parseInt(iris.ref.css('top'));
  iris.w = parseInt(iris.ref.css('width'));
  iris.h = parseInt(iris.ref.css('height'));
  iris.color = iris.ref.css('background-color');
  // start main loop
  animate();
}
// Main animation/logic loop
function animate() {  
  followMouse();
  updateEyeParts();
  mouse.oldX = mouse.x;
  mouse.oldY = mouse.y;
  setTimeout(animate, 16);
}
function updateEyeParts() {
  // iris/pupil movement and color
  iris.ref.css('left', iris.x + 'px');
  iris.ref.css('top', iris.y + 'px');
  iris.ref.css('background', iris.color);
}
// mouse movement event function
$(window).mousemove(function(e){
  distractedFlag = false;
  var eyepos = $('.eye').offset()
  var eyeposx = parseInt(eyepos.left);
  var eyeposy = parseInt(eyepos.top);
  var d = {
    x: e.pageX - r - eyeposx - center.x,
    y: e.pageY - r - eyeposy - center.y
  };
  var distance = Math.sqrt(d.x*d.x + d.y*d.y);
  if (distance < distanceThreshold) {
    mouse.x = e.pageX - eyeposx - r;
    mouse.y = e.pageY - eyeposy - r;
  } 
  else {
    mouse.x = d.x / distance * distanceThreshold + center.x;
    mouse.y = d.y / distance * distanceThreshold + center.y;
  }
});
// move eye according to mouse movement
function followMouse() {
  var lerpSpeed = 0.12;
  xp = interpolate(xp, mouse.x, 0, lerpSpeed);
  yp = interpolate(yp, mouse.y, 0, lerpSpeed);
  iris.x = xp;
  iris.y = yp;
}
// linearly interpolate from part to goalPos (smooth animation effect)
function interpolate(part, goalPos, currentLerp, lerpSpeed) {
		if (part != goalPos) {
			currentLerp = 0;
		}
		if (currentLerp <= 1.0) {
			currentLerp += lerpSpeed;
		}
		part = lerp(part, currentLerp, goalPos);
    return part;
}
// actual formula for linear interpolation 
function lerp(x, t, y) {
  return x * (1-t) + y*t;
}
// get random integer in range min-max
function randomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}